module.exports = __webpack_public_path__ + "static/media/Highland-Lakes-HLCA-BYLAWS-NorthvilleTownship.4b93fa6c.pdf";